import { registerMultiPageApm } from '@/utils/monitor.js';

registerMultiPageApm('index');
